import accountDetailsEN from "./accountDetails.json";
import alertsEN from "./alerts.json";
import barringsEN from "./barrings.json";
import billsEN from "./bills.json";
import forgotEmailEN from "./forgotEmail.json";
import glossaryEN from "./glossary.json";
import navigationEN from "./navigation.json";
import orderEN from "./order.json";
import paymentEN from "./payment.json";
import portinEN from "./portin.json";
import profileEN from "./profile.json";
import simEN from "./sim.json";
import controlEN from "./control.json";
import monthEN from "./month.json";
import usageEN from "./usage.json";
import commonTranslationEN from "./common.json";
import footerTranslationEN from "./footer.json";
import headerTranslationEN from "./header.json";
import selectReasonTranslationEN from "./selectReason.json";
import addressTranslationEN from "./address.json";
import validationTranslationEN from "./validation.json";
import contactEN from "./contact.json";

export const alerts = alertsEN;

export const barrings = barringsEN;

export const bills = billsEN;

export const control = controlEN;

export const glossary = glossaryEN;

export const forgotEmail = forgotEmailEN;

export const navigation = navigationEN;

export const accountDetails = accountDetailsEN;

export const order = orderEN;

export const payment = paymentEN;

export const portin = portinEN;

export const profile = profileEN;

export const sim = simEN;

export const month = monthEN;

export const usage = usageEN;

export const common = commonTranslationEN;

export const footer = footerTranslationEN;

export const header = headerTranslationEN;

export const selectReason = selectReasonTranslationEN;

export const address = addressTranslationEN;

export const validation = validationTranslationEN;

export const contact = contactEN;
